<!-- <div class="dw-red" *ngIf="showError && errorMessage">
    <dw-html-view [ngModel]="errorMessage"></dw-html-view>
</div> -->



NO LONGER USED - LOGIC MOVED TO SCHOOL-CHECK-RIDE-UTIL COMPONENT